import BookProgress, {
  CourseProgressRef,
  LessonProgressRef,
} from './BookProgress';
import { Nullable } from './Model';

export type BookProgressRef = Pick<BookProgress, 'id' | 'progress'>;

export enum ChapterStatusEnum {
  NEVER_OPEN = 'NEVER_OPEN',
  OPEN = 'OPEN',
  READ = 'READ',
}

export default interface ChapterProgress {
  id: number;
  chapterId: number;
  chapterTitle: string;
  timer: number;
  status: ChapterStatusEnum;
  chapterOrder: number;
  progress: number;
  student: number;
}

export interface ChapterProgressUpdate extends ChapterProgress {
  bookProgress: BookProgressRef;
  lessonProgress: Nullable<LessonProgressRef>;
  courseProgress: Nullable<CourseProgressRef>;
}

export function instanceOfChapterProgress(
  object: any,
): object is ChapterProgress {
  return 'id' in object && 'chapterId' in object && 'chapterTitle' in object;
}

export type ChaptersProgressesContent = {
  [key: string]: ChapterProgress;
};
